<template>
    <div class="ue-container">
        <script id="editor" type="text/plain"></script>
    </div>
</template>
<script>
    export default {
        name: 'UE',
        data () {
            return {
                editor: null,
            }
        },
        props: {
            defaultMsg: {
                type: String
            },
            config: {
                type: Object
            }
        },
        /*created() {
            this.editor.created();
        },*/
        mounted() {
            const _this = this;
            this.editor = UE.getEditor('editor', this.config); // 初始化UE
            this.editor.addListener("ready", function () {
                 // _this.editor.setHeight(100 + '%');
                // _this.editor.initialFrameHeight(null)
                //      _this.editor.autoHeightEnabled(false)
                if (_this.defaultMsg){
                    _this.editor.setContent(_this.defaultMsg); // 确保UE加载完成后，放入内容。
                }
            });
        },
        methods: {
            getUEContent() { // 获取内容方法
                return this.editor.getContent()
            },
            setUEContent(t){
                if (t){
                    this.editor.setContent(t);
                }
            }
        },
        destroyed() {
            this.editor.destroy();
        }
    }
</script>
<style lang="scss">
    .ue-container{
        #editor{
            min-height: 500px;

            #edui1{
                #edui1_iframeholder{
                    min-height: 350px !important;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/UEditor.vue